// extracted by LIB_CSS_EXTRACT_LOADER
import "./collapsible_module.css"
export default {"trigger":"trigger-srYWzo","panel":"panel-hN8qN2"};